import { redirect } from 'react-router-dom'
import {
  createStripeInvoice,
  createStripeSubscription,
  getUser,
} from '../helpers/supabase'
import { Plan } from '../types'

export default async function createStripeSubscriptionAction({
  request,
}: {
  request: Request
}) {
  const { currency, plan, priceId, trialPeriodDays } =
    await getFormValues(request)

  if (!currency || !priceId) return redirect('/checkout/plans')

  const { data: userData } = await getUser()

  const email = userData?.user?.user_metadata?.original_email as
    | string
    | undefined

  const urlSearchParams = new URLSearchParams(request.url.split('?')[1])

  const isOneTime = plan === 'one-time'

  const params: Record<string, string> = { plan }

  if (isOneTime) {
    if (!email) return redirect('/checkout/plans')
    const { data } = await createStripeInvoice({ currency, email, priceId })
    params.client_secret = data.clientSecret
    params.currency = data.invoiceCurrency
    params.payment_intent_id = data.paymentIntentId
  } else {
    const { data } = await createStripeSubscription({
      currency,
      priceId,
      trialPeriodDays,
    })
    params.client_secret = data.clientSecret
    params.currency = data.invoiceCurrency
    params.intent_mode = data.mode
    params.subscription_id = data.subscriptionId
    if (trialPeriodDays) {
      params.trial_period_days = trialPeriodDays.toString()
    }
  }

  for (const [key, value] of Object.entries(params)) {
    urlSearchParams.append(key, value)
  }

  return redirect('/checkout/payment?' + urlSearchParams.toString())
}

async function getFormValues(request: Request): Promise<{
  currency: string
  plan: Plan
  priceId: string
  trialPeriodDays?: number
}> {
  const formData = await request.formData()

  const { currency, plan, priceId, trialPeriodDays } =
    Object.fromEntries(formData)

  const parsedTrialPeriodDays =
    typeof trialPeriodDays === 'string'
      ? Number.parseInt(trialPeriodDays, 10)
      : undefined

  return {
    currency,
    plan,
    priceId,
    trialPeriodDays:
      parsedTrialPeriodDays && parsedTrialPeriodDays > 0
        ? parsedTrialPeriodDays
        : undefined,
  } as {
    currency: string
    plan: Plan
    priceId: string
    trialPeriodDays?: number
  }
}
